import { render, staticRenderFns } from "./ManageDrugBatch.vue?vue&type=template&id=a76a8b78&scoped=true&lang=pug&"
import script from "./ManageDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./ManageDrugBatch.vue?vue&type=script&lang=ts&"
import style0 from "./ManageDrugBatch.vue?vue&type=style&index=0&id=a76a8b78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76a8b78",
  null
  
)

export default component.exports